import { autoScrollForElements } from "@atlaskit/pragmatic-drag-and-drop-auto-scroll/element";
import { useMergeRefs } from "@floating-ui/react";
import { useEffect, useRef } from "react";
import type { ChildrenProps, ClassNameProps } from "../types";

export function ScrollableContainer({ children, className }: ChildrenProps & ClassNameProps) {
	/** Hooks */
	const ref = useRef<HTMLDivElement>(null);
	const refs = useMergeRefs([ref]);

	/** Effects */
	useEffect(() => {
		const element = ref.current;
		if (!element) return;
		return autoScrollForElements({
			element,
			getConfiguration: () => ({
				maxScrollSpeed: "standard",
			}),
		});
	}, []);

	/** Render */
	return (
		<div
			ref={refs as any}
			className={className}
		>
			{children}
		</div>
	);
}
